import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';

import { putAccountBeneficiaries } from '@arrived/api_v2';
import { AccountId, ApiError, Beneficiary, BeneficiaryRequest } from '@arrived/models';

import { beneficiariesKeyFn } from '../accounts.keys';

export interface PutAccountsBeneficiariesRequest {
  accountId: AccountId;
  beneficiaries: BeneficiaryRequest[];
}

export function usePutAccountsBeneficiariesMutation(
  options?: UseMutationOptions<Beneficiary[], ApiError, PutAccountsBeneficiariesRequest>
) {
  const queryClient = useQueryClient();

  return useMutation(({ accountId, beneficiaries }) => putAccountBeneficiaries(accountId, beneficiaries), {
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(beneficiariesKeyFn(variables.accountId));

      options?.onSuccess?.(data, variables, context);
    },
  });
}
